import React, { useState } from 'react';
import Slider from 'react-slick';
import RichText from 'components/RichText';
import WebsiteImage from 'components/WebsiteImage';
import WistiaVideo from 'components/Core/WistiaVideo';
import InPageFeaturesCtaButton from 'components/Contentful/ContentfulInPageFeatures/InPageFeaturesV3/InPageFeaturesV3FeaturedContent/InPageFeaturesCtaButton';
import richTextOptions from 'components/Contentful/ContentfulInPageFeatures/InPageFeaturesV3/InPageFeaturesV3FeaturedContent/richTextOptions';
import { useIsColorDark } from 'utils/colorUtility';

import { Container } from './styles';

const MobileCarousel = ({ backgroundColor, inPageNavigation, title, className }) => {
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  return (
    <Container
      className={`in-page-features--content-mobile-container ${className || ''}`}
      background={backgroundColor}
      isDarkBackground={useIsColorDark(backgroundColor)}
      title={title}
    >
      <div className="in-page-features--navigation-content">
        <Slider
          asNavFor={nav2}
          ref={(slider) => setNav1(slider)}
          slidesToShow={1}
          swipeToSlide
          focusOnSelect
          centerMode
          arrows={false}
          variableWidth
        >
          {inPageNavigation.map((item, index) => {
            return (
              <div
                key={`in-page-nav-${index}`}
                id={`mobile_inpagefeatures_navitem_${item.contentful_id}`}
              >
                <div className="in-page-features--navigation-item" key={index}>
                  <h2 className="in-page-features--navigation-item-title">{item.title}</h2>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>

      <div className="in-page-features--main-content">
        <Slider asNavFor={nav1} ref={(slider) => setNav2(slider)} arrows dots>
          {inPageNavigation.map((item, index) => {
            const featuredMp4 =
              item?.featuredImage?.image?.file?.contentType === 'video/mp4' ||
              item?.featuredImage?.bynderMobileImage?.[0]?.videoPreviewURLs?.[0]?.endsWith('mp4') ||
              item?.featuredImage?.bynderDesktopImage?.[0]?.videoPreviewURLs?.[0]?.endsWith('mp4');
            const featuredImage =
              item.featuredImage?.image?.file?.url ||
              item.featuredImage?.bynderDesktopImage?.[0]?.thumbnails?.src ||
              item.featuredImage?.file?.url;

            const { featuredVideo } = item;

            return (
              <div
                key={`in-page-nav-main-${index}`}
                id={`mobile_inpagefeatures_content_${item.contentful_id}`}
              >
                {featuredMp4 && (
                  <div className="in-page-features--video-content">
                    <WebsiteImage {...item?.featuredImage} />
                  </div>
                )}
                {featuredImage && !featuredMp4 && (
                  <div
                    className="in-page-features--image-content"
                    style={{ backgroundImage: `url(${featuredImage})` }}
                  />
                )}
                {featuredVideo && (
                  <div className="in-page-features--video-content">
                    <WistiaVideo dataPosition="In-Page Features" {...featuredVideo} />
                  </div>
                )}
                <div className="in-page-features--description-content" key={index}>
                  {item.description && (
                    <div className="in-page-features--description-content-container">
                      <RichText content={item.description} options={richTextOptions} />

                      {item.link && <InPageFeaturesCtaButton to={item.link} />}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </Container>
  );
};

export default MobileCarousel;
